// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/detail/detail_slider.scss
// module id = 94
// module chunks = 0